exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".rt-tr.-odd {\n  background: #edf3f7;\n}\n.rt-tr:hover .rt-td {\n  background: #fceee7;\n}\n.rt-th.rthfc-th-fixed {\n  z-index: 1000;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/common/reactTableFixedColumns.less
// module id = 4400
// module chunks = 0